import * as React from "react";

/* Logo svg make component */
const LogoComponent = (props) => (
  <svg
    version="1.0"
    width={props?.logoWidth?props.logoWidth:'74%'}
    
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 4720.000000 1080.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
      fill={props?.color}
      stroke={props?.color}
    >
      <path
        d="M1900 5400 l0 -3500 3500 0 3500 0 0 3500 0 3500 -3500 0 -3500 0 0
-3500z m3410 2240 l0 -1080 -535 0 -535 0 0 -535 0 -535 -1080 0 -1080 0 0
1615 0 1615 1615 0 1615 0 0 -1080z m3420 -535 l0 -1615 -1085 0 -1085 0 0
535 0 535 -535 0 -535 0 0 1080 0 1080 1620 0 1620 0 0 -1615z m-2330 -1700
l0 -995 -995 0 -995 0 0 995 0 995 995 0 995 0 0 -995z m-2158 -627 l3 -533
533 -3 532 -2 0 -1085 0 -1085 -1615 0 -1615 0 0 1620 0 1620 1080 0 1080 0 2
-532z m4486 -1085 l-3 -1618 -1617 -3 -1618 -2 0 1085 0 1085 535 0 535 0 0
535 0 535 1085 0 1085 0 -2 -1617z"
      />
      <path
        d="M11950 5415 l0 -1515 345 0 345 0 0 610 0 610 640 0 640 0 0 280 0
280 -640 0 -640 0 0 330 0 330 765 0 765 0 0 295 0 295 -1110 0 -1110 0 0
-1515z"
      />
      <path
        d="M15515 6924 c-337 -51 -585 -167 -801 -376 -204 -198 -335 -444 -401
-757 -25 -116 -27 -145 -28 -366 0 -186 4 -260 17 -330 122 -641 533 -1064
1133 -1167 104 -17 148 -20 325 -15 276 7 412 38 625 143 455 224 732 687 761
1276 19 373 -75 733 -263 1017 -143 215 -396 408 -656 500 -161 57 -261 72
-482 76 -110 2 -213 1 -230 -1z m385 -550 c116 -27 205 -79 300 -174 96 -96
139 -162 186 -288 109 -291 111 -682 4 -975 -125 -340 -417 -523 -764 -479
-359 45 -594 313 -656 747 -13 93 -13 338 1 428 59 396 257 660 551 737 93 24
284 26 378 4z"
      />
      <path
        d="M17490 5420 l0 -1510 345 0 345 0 0 576 0 575 333 -3 c312 -3 336 -5
399 -26 90 -30 155 -77 203 -148 74 -108 92 -191 120 -550 18 -237 38 -366 60
-400 l15 -24 345 0 c243 0 345 3 345 11 0 6 -9 24 -20 40 -29 40 -46 142 -70
421 -34 394 -50 486 -110 616 -64 136 -167 229 -328 294 -35 14 -63 29 -63 33
0 4 36 22 80 40 119 47 187 92 271 175 58 58 85 94 118 160 61 125 76 198 76
370 0 170 -19 253 -87 384 -127 245 -361 401 -685 456 -107 19 -165 20 -903
20 l-789 0 0 -1510z m1535 932 c103 -39 187 -126 221 -231 27 -82 24 -227 -5
-303 -27 -70 -93 -145 -158 -181 -104 -56 -136 -60 -535 -65 l-368 -4 0 407 0
406 393 -3 c378 -3 394 -4 452 -26z"
      />
      <path
        d="M20200 6635 l0 -295 450 0 450 0 0 -1220 0 -1220 345 0 345 0 0 1220
0 1220 453 2 452 3 3 293 2 292 -1250 0 -1250 0 0 -295z"
      />
      <path
        d="M23030 5420 l0 -1510 1150 0 1150 0 0 295 0 295 -805 0 -805 0 0 350
0 350 685 0 685 0 0 275 0 275 -685 0 -685 0 2 303 3 302 788 3 787 2 0 285 0
285 -1135 0 -1135 0 0 -1510z"
      />
      <path
        d="M25708 6903 c11 -16 220 -340 466 -721 l447 -693 -29 -47 c-16 -26
-242 -378 -502 -782 -260 -404 -475 -741 -477 -748 -4 -10 75 -12 388 -10
l392 3 180 305 c158 269 351 632 417 788 12 28 26 52 30 52 4 0 29 -48 55
-107 110 -247 222 -465 383 -743 l170 -295 406 -3 c234 -1 406 2 406 7 0 5
-225 363 -500 796 -291 457 -497 791 -493 798 4 7 205 325 448 707 243 382
445 701 449 708 6 9 -71 12 -371 12 l-378 0 -156 -263 c-183 -306 -226 -385
-324 -593 -41 -85 -76 -155 -80 -155 -4 0 -33 55 -65 123 -111 240 -194 396
-339 640 l-146 248 -398 0 -398 0 19 -27z"
      />
      <path
        d="M30270 5420 l0 -1511 678 4 c643 3 682 4 767 24 688 159 1052 713
1022 1558 -12 318 -65 552 -177 775 -169 335 -444 545 -828 632 -94 21 -120
22 -779 25 l-683 4 0 -1511z m1380 1121 c127 -32 256 -100 340 -178 160 -148
241 -315 291 -599 20 -109 23 -163 23 -354 0 -243 -11 -340 -59 -504 -103
-354 -327 -561 -674 -620 -76 -13 -172 -16 -488 -16 l-393 0 0 1151 0 1150
438 -4 c410 -3 442 -5 522 -26z"
      />
      <path
        d="M33080 5420 l0 -1510 1095 0 1095 0 0 185 0 185 -890 0 -890 0 2 513
3 512 783 3 782 2 0 170 0 170 -785 0 -785 0 0 460 0 460 870 0 870 0 0 180 0
180 -1075 0 -1075 0 0 -1510z"
      />
      <path
        d="M36275 6919 c-401 -51 -697 -276 -771 -586 -22 -90 -22 -285 0 -377
24 -100 85 -211 159 -286 158 -159 330 -233 782 -335 554 -125 720 -206 812
-393 36 -74 45 -239 18 -338 -34 -128 -128 -235 -260 -298 -115 -55 -180 -68
-375 -73 -147 -4 -191 -1 -276 15 -316 63 -507 234 -580 518 -13 53 -24 107
-24 120 l0 24 -200 0 c-110 0 -200 -3 -200 -7 0 -44 35 -219 55 -278 104 -310
317 -518 653 -639 168 -60 452 -91 683 -75 630 46 998 423 940 963 -7 58 -19
129 -27 158 -37 123 -135 268 -235 345 -175 135 -325 190 -809 298 -399 89
-546 144 -646 240 -63 62 -89 112 -104 196 -22 123 20 261 104 342 60 59 165
112 272 139 127 32 370 32 496 0 250 -62 401 -210 458 -447 l17 -70 191 -3
c220 -3 203 -12 177 100 -37 160 -102 303 -183 404 -148 183 -397 308 -687
343 -104 13 -338 12 -440 0z"
      />
      <path
        d="M38030 5420 l0 -1510 210 0 210 0 0 1510 0 1510 -210 0 -210 0 0
-1510z"
      />
      <path
        d="M39980 6924 c-214 -26 -424 -103 -605 -222 -209 -138 -410 -414 -498
-687 -121 -373 -123 -828 -6 -1180 142 -424 455 -742 855 -868 143 -45 265
-60 457 -54 209 5 292 24 453 102 160 77 300 198 388 332 12 18 24 33 27 33 7
0 28 -74 80 -282 l31 -128 129 0 129 0 0 770 0 770 -620 0 -620 0 0 -170 0
-170 421 0 422 0 -6 -122 c-18 -411 -247 -690 -633 -774 -118 -25 -323 -23
-438 5 -373 91 -633 385 -728 824 -30 138 -32 468 -4 622 83 461 318 741 704
837 73 19 116 22 262 22 199 1 285 -16 409 -78 160 -81 287 -233 351 -421 l17
-50 206 -3 c134 -1 207 1 207 8 0 23 -65 211 -96 275 -146 310 -408 509 -774
590 -73 16 -433 29 -520 19z"
      />
      <path
        d="M41750 5420 l0 -1510 195 0 195 0 0 1041 c0 619 -4 1119 -11 1235 -6
107 -9 199 -7 206 2 6 38 -52 80 -128 150 -272 220 -384 858 -1363 l645 -990
218 -1 217 0 0 1510 0 1510 -195 0 -195 0 0 -1012 c0 -909 5 -1171 26 -1418 4
-51 3 -72 -4 -65 -5 6 -45 75 -87 155 -148 279 -200 362 -843 1345 l-648 990
-222 3 -222 2 0 -1510z"
      />
    </g>
   {/*  <svg
    width={199}
    height={34}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
    d="M46.617 10.631h10.52v2.795h-7.244v3.12h6.05v2.68h-6.05v5.742h-3.276V10.631ZM64.444 24.966c-1.05 0-1.993-.178-2.83-.536a6.17 6.17 0 0 1-2.145-1.498 6.63 6.63 0 0 1-1.36-2.274 8.391 8.391 0 0 1-.472-2.85c0-1.024.158-1.99.471-2.866a6.49 6.49 0 0 1 1.36-2.266 6.374 6.374 0 0 1 2.146-1.5c.84-.362 1.783-.545 2.83-.545 1.046 0 1.972.183 2.812.546.84.363 1.553.864 2.145 1.499a6.505 6.505 0 0 1 1.36 2.266c.314.877.472 1.832.472 2.866a8.35 8.35 0 0 1-.472 2.85 6.546 6.546 0 0 1-1.36 2.273 6.17 6.17 0 0 1-2.145 1.5c-.84.357-1.775.535-2.813.535Zm.02-2.59c.592 0 1.11-.116 1.552-.35a3.209 3.209 0 0 0 1.111-.963c.297-.408.519-.89.667-1.442a6.997 6.997 0 0 0 .222-1.813c0-.654-.074-1.261-.222-1.822a4.542 4.542 0 0 0-.667-1.471 3.134 3.134 0 0 0-1.11-.98c-.445-.235-.964-.35-1.554-.35-.59 0-1.113.115-1.562.35-.45.234-.828.56-1.129.98-.301.42-.53.909-.684 1.471a6.894 6.894 0 0 0-.232 1.822c0 .655.077 1.257.232 1.813a4.31 4.31 0 0 0 .684 1.442c.301.407.68.728 1.129.962.449.235.97.351 1.562.351ZM72.824 10.631h6.822a6.67 6.67 0 0 1 1.936.27c.597.18 1.113.446 1.55.8.437.352.78.782 1.032 1.29.25.51.375 1.09.375 1.744 0 .847-.212 1.567-.634 2.157-.425.59-1.099 1.035-2.022 1.329v.057c.718.22 1.249.543 1.59.972.34.43.563 1.03.664 1.803.064.488.11.948.145 1.377.033.43.065.815.097 1.156.032.34.074.617.126.83.052.212.136.343.249.394v.153h-3.237c-.103-.051-.177-.18-.222-.385a7.315 7.315 0 0 1-.116-.76c-.032-.301-.062-.64-.086-1.012a43.475 43.475 0 0 0-.097-1.156c-.088-.718-.323-1.259-.703-1.62-.38-.36-.966-.538-1.763-.538h-2.427v5.471h-3.276V10.631h-.003Zm3.276 6.437h2.909c.733 0 1.291-.17 1.676-.511.385-.341.578-.8.578-1.378 0-.578-.178-1.062-.53-1.417-.354-.353-.897-.53-1.628-.53H76.1V17.067ZM85.66 10.631h11.831v2.795h-4.276v11.542h-3.294V13.424h-4.258v-2.795l-.003.002ZM99.082 10.631h10.752v2.736h-7.476v2.851h6.474v2.6h-6.474v3.333h7.612v2.812H99.085V10.631h-.003ZM116.068 17.47l-4.412-6.839h3.758l1.155 1.946c.168.281.334.587.502.916.168.328.321.64.461.935.153.334.314.682.482 1.04h.039c.153-.36.314-.706.482-1.04a24.295 24.295 0 0 1 .982-1.851l1.176-1.946h3.584l-4.335 6.822 4.777 7.515h-3.891l-1.444-2.523a10.74 10.74 0 0 1-.491-.936c-.161-.34-.311-.659-.452-.953l-.462-1.039h-.039c-.153.346-.316.694-.482 1.04-.14.296-.298.612-.471.952-.173.341-.343.652-.511.936l-1.484 2.523h-3.738l4.817-7.495-.003-.003ZM133.336 10.631h5.298c1.067 0 2 .173 2.802.521a5.329 5.329 0 0 1 2.005 1.474c.534.637.931 1.398 1.195 2.284.264.886.395 1.869.395 2.948s-.138 2.037-.415 2.908c-.276.874-.691 1.622-1.241 2.245a5.554 5.554 0 0 1-2.042 1.444c-.81.34-1.753.51-2.832.51h-5.163V10.632h-.002Zm5.086 12.621c.81 0 1.503-.125 2.081-.375a3.55 3.55 0 0 0 1.417-1.079c.366-.469.637-1.037.81-1.706.173-.666.259-1.412.259-2.234 0-.822-.081-1.573-.242-2.254-.16-.682-.417-1.262-.77-1.743a3.526 3.526 0 0 0-1.377-1.119c-.566-.264-1.252-.395-2.062-.395h-3.217v10.905h3.101ZM146.625 10.631h10.192v1.733h-8.227V16.7h7.437v1.637h-7.437v4.836h8.439v1.793h-10.404V10.63ZM163.354 24.966c-.965 0-1.807-.124-2.53-.37-.724-.247-1.328-.586-1.817-1.01a4.328 4.328 0 0 1-1.121-1.511 5.24 5.24 0 0 1-.445-1.854h1.874c.111 1.051.506 1.851 1.188 2.402.679.55 1.649.825 2.911.825.456 0 .881-.052 1.271-.159.39-.103.724-.259 1.003-.464.279-.205.498-.459.659-.77.16-.309.242-.674.242-1.094 0-.444-.097-.814-.287-1.113a2.267 2.267 0 0 0-.817-.74 5.727 5.727 0 0 0-1.261-.502 33.493 33.493 0 0 0-1.642-.408 16.728 16.728 0 0 1-1.753-.444 5.373 5.373 0 0 1-1.457-.696 3.221 3.221 0 0 1-.992-1.084c-.242-.432-.361-.983-.361-1.65 0-.58.116-1.1.353-1.557.235-.457.563-.845.983-1.158.42-.316.923-.556 1.511-.723a7.028 7.028 0 0 1 1.938-.25c.852 0 1.587.102 2.207.306.617.205 1.141.487 1.568.845.427.358.758.785.992 1.279.235.493.395 1.04.482 1.632h-1.837c-.123-.84-.477-1.482-1.057-1.919-.58-.44-1.36-.659-2.335-.659-.916 0-1.645.18-2.188.538-.543.358-.817.884-.817 1.575 0 .37.089.684.269.936.178.255.427.467.741.64a5.14 5.14 0 0 0 1.131.437c.439.118.918.232 1.436.343a26.27 26.27 0 0 1 1.919.464 5.769 5.769 0 0 1 1.632.733c.476.316.852.721 1.131 1.215.279.494.417 1.126.417 1.891 0 .654-.126 1.237-.38 1.743-.255.506-.61.933-1.067 1.28a4.873 4.873 0 0 1-1.632.787c-.63.18-1.316.269-2.059.269l-.003-.005ZM170.078 10.631h1.965v14.335h-1.965V10.63ZM184.401 22.727h-.057c-.493.753-1.101 1.313-1.822 1.683-.721.37-1.533.556-2.432.556-.962 0-1.836-.175-2.626-.529a5.96 5.96 0 0 1-2.035-1.47 6.433 6.433 0 0 1-1.331-2.248c-.308-.869-.461-1.827-.461-2.876 0-1.05.148-2.012.444-2.893a6.575 6.575 0 0 1 1.314-2.304 5.837 5.837 0 0 1 2.044-1.479c.807-.358 1.748-.536 2.822-.536.815 0 1.538.104 2.172.314.635.21 1.188.503 1.657.879.469.375.852.827 1.146 1.35.296.524.511 1.101.647 1.729h-1.961a3.655 3.655 0 0 0-1.202-1.907c-.593-.493-1.417-.74-2.479-.74-.802 0-1.499.14-2.091.425a3.953 3.953 0 0 0-1.462 1.175 5.057 5.057 0 0 0-.851 1.775 8.403 8.403 0 0 0-.277 2.21c0 .787.114 1.557.343 2.229.227.672.546 1.25.953 1.728.408.482.894.855 1.462 1.119.568.266 1.19.397 1.869.397s1.274-.108 1.785-.323a3.494 3.494 0 0 0 1.266-.88c.334-.37.583-.797.748-1.285.166-.487.25-1.003.25-1.546v-.296h-3.995v-1.61h5.864v7.288h-1.203l-.498-1.943-.003.008ZM187.691 10.631h2.062l5.876 8.98c.18.269.363.568.548.896.185.328.356.64.511.933.18.334.361.674.541 1.022h.057c-.028-.36-.052-.718-.077-1.078a14.898 14.898 0 0 1-.049-1.003c-.008-.36-.01-.686-.01-.983v-8.767h1.849v14.335h-2.042l-5.856-8.98c-.18-.269-.363-.565-.548-.886-.185-.32-.363-.63-.531-.926-.193-.333-.38-.674-.558-1.022h-.039c.012.36.032.719.056 1.079l.04.983c.012.345.02.669.02.963v8.786h-1.85V10.631Z"
    fill={props?.color}
  />
  <path stroke={props?.color} strokeWidth={0.8} d="M1 1h32v32H1z" />
  <path stroke={props?.color} strokeWidth={0.8} d="M12 12h10v10H12z" />
  <path
    stroke={props?.color}
    d="M16.5 12V1M12.152 17.5H1.243M17.5 21.848v10.909M22 16.5h11"
  />


</svg> */}
  </svg>
);

export default LogoComponent;
